/**
 * 作為和interactiveCanvas交互的媒介
 */
export class Assistant{
  constructor(opts = {}){
    this.ready = false
    this.canvas = window.interactiveCanvas
    this.commands = {
      '$ANY': [],
      /** 收到訊息後啟動stt */
      'stt.start': [()=>{}]
    }
    this.ttsCallbacks = [
      (mark)=>{
        if(mark === 'START'){
          this.ttsStatus = Assistant.TTS.PLAYING
        }else if(mark === 'END'){
          this.ttsStatus = Assistant.TTS.STOP
        }else if(mark === 'ERROR'){
          console.warn(`tts mark = 'ERROR'`)
          this.ttsStatus = Assistant.TTS.STOP
        }
      }
    ]
    this.ttsStatus = Assistant.TTS.STOP
  }

  query(text){
    return this.canvas.sendTextQuery(text)
  }

  getHeaderHeightPx(){
    return this.canvas.getHeaderHeightPx()
  }

  static getHeaderHeightPx(){
    return window.interactiveCanvas.getHeaderHeightPx()
  }
  /**
   * 讓 assistant 念出指定的內容
   */
  startTTS(text){
    console.debug('sendTextQuery', `cmd/speech:${text}`)
    return this.query(`cmd/speech:${text}`)
  }
  /**
   * 讓 assistant 開始聽用戶聲音
   */
  startSTT(){
    return this.query('cmd/stt.start')
  }

  addTTSCallback(cb){
    this.ttsCallbacks.push(cb)
    return cb
  }
  removeTTSCallback(cb){
    for(let i in this.ttsCallbacks){
      if(this.ttsCallbacks[i] === cb){
        this.ttsCallbacks.splice(i, 1)
        break
      }
    }
  }

  addCallback(key, cb){
    if(!(key in this.commands)){
      this.commands[key] = []
    }
    this.commands[key].push(cb)
    return cb
  }

  removeCallback(key, cb){
    let cbList = this.commands[key]
    if(cbList){
      let removeIndex = -1
      for(let i in cbList){
        if(cbList[i] === cb){
          removeIndex = i
          break
        }
      }
      if(removeIndex >= 0){
        cbList.splice(removeIndex, 1)
      }
      return removeIndex >= 0
    }
  }

  simUpdate(data){
    this._canvasCallbacks.onUpdate(data)
  }

  setup(){
    if(this.ready){
      return
    }
    this.canvas = window.interactiveCanvas
    this.ready = true
    const callbacks = this._canvasCallbacks = {
      /**
       * @param {string} markName START | END | ERROR
       */
      onTtsMark: async (markName)=>{
        for(let cb of this.ttsCallbacks){
          await cb(markName)
        }
      },
      onUpdate: async (data)=>{
        try {
          if(data.command !== 'speech' && data.command !== 'stt.start'){
            for(let cb of this.commands['$ANY']){
              await cb(data)
            }
          }
          if(this.commands[data.command]){
            for(let cb of this.commands[data.command]){
              await cb(data)
            }
          }
        } catch (e) {
          console.error('callback failed')
          console.error(e)
        }
      }
    }
    this.canvas.ready(callbacks)
  }
  static getInstance(){
    return instance
  }
}
/**
 * 表示 tts 的狀態
 */
Assistant.TTS = {
  PLAYING: 'PLAYING',
  STOP: 'STOP'
}
/**
 * dev frame 用
 */
export class STTEvent{
  constructor(data){
    this.type = 'payload'
    this.requestId = null
    // 從dialogflow 收到的data
    this.data = data
  }
}
/**
 * dev frame 用
 */
export class TTSMarkEvent{
  constructor(opts = {}){
    this.type = 'TtsEndpointEvent'
    this.index = 1
    this.numTts = 1
    this.ttsState = opts.name === 'START' ? 1 : opts.name === 'END' ? 2 : -1
    this.name = opts.name
  }
}

export let instance = new Assistant()
// 別名
export let assistant = instance
export default Assistant
